import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { ReleasesGrid } from '../ReleasesView.styles'
import { ReleaseCardContainer } from 'components/ReleaseCard/ReleaseCard.styles'
import {
  RESPONSIVE_BREAKPOINT_VERSIONS,
  useResponsiveBreakpointsVersion
} from 'contexts/ResponsiveBreakpointsContext'

const SKELETON_CARD_COUNT = 25

const CardSkeleton = () => {
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2

  return (
    <ReleaseCardContainer $responsiveBreakpointsV2={responsiveBreakpointsV2}>
      <div
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '1 / 1',
          maxWidth: 214
        }}
      >
        <Skeleton height="100%" width="100%" />
      </div>

      <div className="h-24 w-40 mt-4">
        <Skeleton height={20} width="80%" />
        <Skeleton height={20} width="60%" style={{ marginTop: 6 }} />
      </div>
    </ReleaseCardContainer>
  )
}

export default function ReleaseCardSkeleton() {
  const responsiveBreakpointsVersion = useResponsiveBreakpointsVersion()
  const responsiveBreakpointsV2 =
    responsiveBreakpointsVersion === RESPONSIVE_BREAKPOINT_VERSIONS.V2

  return (
    <ReleasesGrid $responsiveBreakpointsV2={responsiveBreakpointsV2}>
      {Array(SKELETON_CARD_COUNT)
        .fill()
        .map((_, index) => (
          <CardSkeleton key={index} />
        ))}
    </ReleasesGrid>
  )
}
